import React from "react";
import { getNotificacionesII } from "../pages/config/helpers/api.helper";
import moment from "moment";
import { useSelector } from "react-redux";
import { useIsAuthenticated } from "@azure/msal-react";

export const NotificationsContext = React.createContext();

function NotificationsProvider({ children }) {
  const [notificaciones, setNotificaciones] = React.useState([]);
  const [notificacionGlobalActivas, setNotificacionGlobalActivas] =
    React.useState(false);
  const [update, setUpdate] = React.useState(false);
  const isAuthenticated = useIsAuthenticated();
  const { user } = useSelector((state) => state.user);

  const handleGetNotifications = async () => {
    if (!isAuthenticated || !user?.username) return;
    try {
      const notifications = await getNotificacionesII({
        destinatarioNBS: user?.username,
        inicio: moment().subtract(1, "days").format("YYYY-MM-DD"),
        fin: moment().format("YYYY-MM-DD"),
      });

      if (notifications.status === 200) {
        notifications.data.sort(
          (a, b) =>
            new Date(b.fechaCreacionNBS).getTime() -
            new Date(a.fechaCreacionNBS).getTime()
        );
        setNotificaciones(notifications.data);
      }
    } catch (error) {
      console.log("Error al obtener las notificaciones");
      console.error(error);
    }
  };

  React.useEffect(() => {
    handleGetNotifications();
  }, [update, user?.username, isAuthenticated]);

  return (
    <NotificationsContext.Provider
      value={{
        notificaciones,
        setNotificaciones,
        setUpdate,
        notificacionGlobalActivas,
        setNotificacionGlobalActivas,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
}

export default NotificationsProvider;
